import React from "react";
import { Link } from "react-router-dom";
import { PaDataTable, PaSkeleton } from "components/platform-admin";

const FinancialPlansTable = ({ rows = [], loading = false }) => (
  <section className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
    <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h2 className="text-sm font-semibold text-gray-900">Revenue by plan</h2>
        <p className="mt-0.5 text-xs text-gray-500">
          Plan mix and estimated MRR contribution across tenants.
        </p>
      </div>
      <Link
        to="/stripe?tab=assignments"
        className="text-xs font-medium text-indigo-600 hover:text-indigo-700"
      >
        Plan assignments →
      </Link>
    </div>
    {loading ? (
      <PaSkeleton variant="table" lines={4} />
    ) : rows.length === 0 ? (
      <p className="text-sm text-gray-500">No billing plans assigned yet.</p>
    ) : (
      <PaDataTable
        columns={[
          { key: "plan_name", label: "Plan", render: (row) => row.plan_name },
          {
            key: "tenant_count",
            label: "Tenants",
            headerClassName: "text-right",
            cellClassName: "text-right tabular-nums",
            render: (row) => row.tenant_count,
          },
          {
            key: "paying_count",
            label: "Paying",
            headerClassName: "text-right",
            cellClassName: "text-right tabular-nums",
            render: (row) => row.paying_count,
          },
          {
            key: "trial_count",
            label: "Trial",
            headerClassName: "text-right",
            cellClassName: "text-right tabular-nums",
            render: (row) => row.trial_count,
          },
          {
            key: "failed_count",
            label: "Failed",
            headerClassName: "text-right",
            cellClassName: "text-right tabular-nums",
            render: (row) => row.failed_count,
          },
          {
            key: "estimated_revenue",
            label: "Est. MRR",
            headerClassName: "text-right",
            cellClassName: "text-right",
            render: (row) => row.estimated_revenue,
          },
        ]}
        rows={rows}
        rowKey="id"
      />
    )}
  </section>
);

export default FinancialPlansTable;
